<template>
    <div>
        <div v-for="(a, i) in oneroom" :key="i">
        <img :src="a.image" class="room-img">
        <h4 @click="$emit('openModal', i)">{{a.title}}</h4>
        <p>{{a.price}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        oneroom : Array,
        modalData : Boolean
    }
}
</script>

<style scoped>

</style>